import request from "../request";

export const check = ({email}) => {
	return request({
		url: "/user/check",
		data: {
			email,
		},
		needOverlay: false,
	});
};

export const fastRegisterAjax = ({eventId, type, FastRegistrationForm, csrf, ajax}) => {
	return request({
		url :`/user/registration/ajax-fast-register?event_id=${eventId}&type=${type}`,
		data: {
			FastRegistrationForm,
			'_csrf-frontend': csrf,
			ajax
		},
		needOverlay: true,
	})
}
